/**
 * Download the HTML image element in Fetch API style.
 *
 * Sources:
 * - https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/crossOrigin
 * @param {string} src Source of the image.
 * @param {object} [opts]
 * @param {string} [opts.crossOrigin] CORS setting to use when retrieving the image.
 * @returns {HTMLImageElement}
 */
const fetchImage = async (src, { crossOrigin } = {}) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = crossOrigin;
    image.src = src;
    // TODO Use EventListener instead of on* callbacks.
    image.onload = () => resolve(image);
    image.onerror = error => reject(error);
  });
};

export default fetchImage;
